import React from 'react';
import { db } from '../firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';
import H2 from './H2/H2';
import './ToggleVisibilityPopup.css';

const ToggleVisibilityPopup = ({ item, onClose, onVisibilityChange }) => {
  const handleToggleVisibility = async () => {
    try {
      const itemRef = doc(db, 'mural', item.id);
      await updateDoc(itemRef, {
        isVisible: !item.isVisible,
        updatedAt: new Date()
      });
      onVisibilityChange(item.id, !item.isVisible);
      onClose();
    } catch (error) {
      console.error('Error toggling visibility:', error);
      alert('Erro ao alterar visibilidade do item.');
    }
  };

  return (
    <div className="modal-container">
      <div className="modal-content">
        <button
          className="close-btn"
          onClick={onClose}
        >
          {"X"}
        </button>

        <H2 text={item.isVisible ? "Ocultar item" : "Tornar item visível"} textColor="purple" />
        
        <p className="mt-4 text-gray-600">
          {item.isVisible 
            ? "Tem certeza que deseja ocultar este item? Ele não será mais visível no mural."
            : "Tem certeza que deseja tornar este item visível novamente no mural?"}
        </p>

        <div className="modal-actions">
          <button 
            className="cancel-btn"
            onClick={onClose}
          >
            Cancelar
          </button>
          <button 
            className="confirm-btn"
            onClick={handleToggleVisibility}
          >
            {item.isVisible ? "Ocultar" : "Tornar visível"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToggleVisibilityPopup; 